const hyphenate = require('./hyphenate');
const toTitleCase = require('./to-title-case');

module.exports = {
    hyphenate,
    toTitleCase
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/stringhelpers/index.js
 **/